import Tab from './src/tab'
import TabItem from './src/tabItem'

Tab.item = TabItem;

export default Tab;
